<template>
  <div class="main-container-graphic">
		<div>
			<title-header
				class="mb-4"
				:poll-name="poll.name"
				title="CÓDIGO ASIGNADO"
				url-image="/static/img/diagnosis/dashboard.svg"
			>
				<v-layout row wrap justify-end align-center>
					<subsidiary-filter
						:subsidiaries="subsidiaries"
						:subsidiary-selected="subsidiarySelected"
						@change-subsidiary="changeSubsidiary"
					></subsidiary-filter>
					<area-filter
						:areas="areas"
						:area-selected="areaSelected"
						@change-area="changeArea"
					></area-filter>
					<download-btn
						alt="Descargar reporte en PDF"
						:height="27"
						url-image="/static/img/icons/pdf.svg"
						@download-item="downloadReport('pdf')"
					></download-btn>
					<download-btn
						alt="Descargar reporte en Excel"
						:height="23"
						url-image="/static/img/icons/excel.webp"
						@download-item="downloadReport('xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel')"
					></download-btn>
					<v-btn
						class="btn-detail btn-action"
						color="primary"
						@click="goToBack"
					>
						<img
							src="/static/img/icons/btn-right-arrow.webp"
							height="13"
							alt="Atrás"
						/>
						Atrás
					</v-btn>
				</v-layout>
			</title-header>
			<v-layout wrap pl-4>
				<v-flex xs5 pb-4>
					<row-graphic
						:border="false"
						gray
						legend-border-right
						:row="graphic"
						without-background
					/>
				</v-flex>
			</v-layout>
			<v-layout wrap>
				<v-flex v-if="isLoaded" v-for="style in styles" :key="style.hierarchyId" xs4 px-4>
					<card-tool
						:data="style"
						small
						small-height
						:card-reverse="style.cardReverse"
						@reverse-card="reverseCard"
					/>
				</v-flex>
			</v-layout>
			<v-layout justify-space-between mt-4>
				<v-flex xs5 class="summary-one" px-3>
					<div class="wrapper-summary">
						<div class="wrapper-text">
							<div
								class="blue-bold primary--text"
								:style="`color:${$appColors.primary}`"
							>RESUMEN ESTUDIO DE</div>
							<div
								class="blue-bold"
								:style="`color:${$appColors.primary}`"
							>CULTURA ORGANIZACIONAL</div>
						</div>
						<graphic-style
							v-if="load"
							class="mr-3"
							:data="summaryStudy"
							:area-id="1"
							:width="widthSummaryOne"
							:radius="75"/>
					</div>
				</v-flex>
				<v-flex xs7 class="summary-two" px-3>
					<div class="wrapper-summary">
						<div class="wrapper-text">
							<div class="blue-bold" :style="`color:${$appColors.primary};`">ESTILOS</div>
							<div class="blue-bold" :style="`color:${$appColors.primary};`">DE CULTURAS</div>
						</div>
						<graphic-style
							v-if="load"
							:data="summaryCulture"
							:area-id="2"
							:width="widthSummaryTwo"
							:radius="110"/>
					</div>
				</v-flex>
			</v-layout>
			<div class="wrapper-close">
				<v-btn
					class="btn-detail btn-action btn-detail-close"
					color="primary"
					@click="goToBack"
				>
					Cerrar
				</v-btn>
			</div>
		</div>
	</div>
</template>
<script>
import areaFilter from '@/components/diagnosis/area-filter';
import subsidiaryFilter from '@/components/diagnosis/subsidiary-filter';
import cardTool from '@/components/diagnosis/card-tool';
import downloadBtn from '@/components/diagnosis/download-btn';
import graphicStyle from '@/components/diagnosis/graphic-styles';
import helper from '@/shared/helper';
import rowGraphic from '@/components/surveys/action-one/row-graphic';
import titleHeader from '@/components/diagnosis/title-header';

const { generateBlob, showDownloadDialog } = helper;

// async function created() {
// 	({ data: this.subsidiaries } = await this.$httpPraktiko.get('subsidiaries'));
// 	const newSubsidiary = { code: 'SUB0', id: null, name: 'Todas las Sucursales' };
// 	this.subsidiaries.unshift(newSubsidiary);
// }

function data() {
	return {
		areaId: null,
		subsidiaryId: null,
		areas: [],
		subsidiaries: [],
		areaSelected: null,
		subsidiarySelected: null,
		graphic: [
			{ image: '/static/img/diagnosis/app.svg', number: 0, numberTotal: 0, description: 'Aplicantes' },
			{ image: '/static/img/diagnosis/male.svg', number: 0, numberTotal: 0, description: 'Masculino' },
			{ image: '/static/img/diagnosis/female.svg', number: 0, numberTotal: 0, description: 'Femenino' },
		],
		load: false,
		poll: {},
		styles: [],
		summaryCulture: [],
		summaryStudy: [],
		widthSummaryOne: 0,
		widthSummaryTwo: 0,
		isLoaded: false,
	};
}

async function downloadReport(type, contentType) {
	const body = {
		id: this.idsummary,
	};
	if (this.areaId) {
		body.areaId = this.areaId;
	}
	if (this.subsidiaryId) {
		body.subsidiaryId = this.subsidiaryId;
	}
	if (type === 'xlsx') {
		body.excel = true;
	}
	try {
		if (type === 'pdf') {
			const myGraphs = document.getElementById('canvas-1').toDataURL();
			const myGraphs2 = document.getElementById('canvas-2').toDataURL();
			const graphs = [myGraphs, myGraphs2];
			body.base64 = graphs;
		}
		const { data: pdfData } = await this.$httpPraktiko.post(
			`reports/organizational-culture-inventory/${type}`, body, { responseType: 'blob' });
		const blob = generateBlob(pdfData, contentType);
		showDownloadDialog(blob, 'reporte_inventario_de_cultura_organizacional', type);
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	}
}

function changeArea(areaId) {
	this.areaId = areaId || null;
	this.loadData();
}

function changeSubsidiary(subsidiaryId) {
	this.subsidiaryId = subsidiaryId || null;
	this.loadData();
}

async function mounted() {
	this.widthSummaryOne = document.getElementsByClassName('summary-one')[0].clientWidth - 70;
	this.widthSummaryTwo = document.getElementsByClassName('summary-two')[0].clientWidth * 0.8;
	this.widthSummaryTwo = this.widthSummaryTwo > 530 ? 530 : this.widthSummaryTwo;
	({ data: this.subsidiaries } = await this.$httpPraktiko.get('subsidiaries'));
	const newSubsidiary = { code: 'SUB0', id: null, name: 'Todas las Sucursales' };
	this.subsidiaries.unshift(newSubsidiary);
	const { areaId, subsidiaryId } = this.$route.params;
	if (areaId) {
		this.areaId = areaId;
		this.areaSelected = areaId;
	}
	if (subsidiaryId) {
		this.subsidiaryId = subsidiaryId;
		this.subsidiarySelected = subsidiaryId;
	}
	this.loadData();
}

function goToBack() {
	// const { query, params } = this.$route;
	// const name = query ? query.back : 'detail-summary-inventory';
	// const { toolId } = params;
	this.$router.go(-1);
	// this.goTo(name, { params: { toolId, id: this.id } });
}

async function loadData() {
	const defaultColors = ['#f94444', '#ffd700', '#5ed52b', '#487fff'];
	this.load = false;
	const params = {};
	if (this.areaId) {
		params.areaId = this.areaId;
	}
	if (this.subsidiaryId) {
		params.subsidiaryId = this.subsidiaryId;
	}
	this.summaryCulture = [];
	try {
		const { data: response } = await this.$httpPraktiko.get(
			`diagnostic-detail/${this.idsummary}/item`, { params });
		this.poll = response.poll;
		const newArea = { code: 'GE01', id: null, name: 'Todas las Áreas' };
		response.groups.unshift(newArea);
		this.areas = response.groups.map(ac =>
			({ code: ac.code, id: ac.id, name: ac.name }));
		this.styles = response.reportData.map((rd) => {
			const newRd = { ...rd };
			newRd.cardReverse = false;
			return newRd;
		});
		this.summaryStudy = response.reportData.map((r, index) => {
			const newSummary = {
				name: r.name.toUpperCase(),
				value: r.total,
				color: r.color || defaultColors[index],
			};
			r.entities.forEach((c) => {
				const newCulture = {
					name: c.name.toUpperCase(),
					value: c.total,
					color: r.color || defaultColors[index],
				};
				this.summaryCulture.push(newCulture);
			});
			return newSummary;
		});
		this.setGraphics(response);
		this.load = true;
		this.isLoaded = false;
		this.$nextTick(() => {
			this.isLoaded = true;
		});
	} catch (error) {
		// this.showGenericError();
		this.showGenericError('No hay coincidencias entre la agencia y el área seleccionada. Asegúrate de que ambos datos sean correctos.');
	}
}

function setGraphics(res) {
	this.graphic[0].number = this.areaId || this.subsidiaryId ?
		res.reportData[0].numApplicants : res.totalResolved || 0;
	this.graphic[0].numberTotal = this.areaId || this.subsidiaryId ?
		res.reportData[0].numApplicants : res.numApplicants || 0;
	this.graphic[1].number = this.areaId || this.subsidiaryId ?
		res.reportData[0].numMale : res.numMale || 0;
	this.graphic[1].numberTotal = this.areaId || this.subsidiaryId ?
		res.reportData[0].numMale : res.numTotalMale || 0;
	this.graphic[2].number = this.areaId || this.subsidiaryId ?
		res.reportData[0].numFemale : res.numFemale || 0;
	this.graphic[2].numberTotal = this.areaId || this.subsidiaryId ?
		res.reportData[0].numFemale : res.numTotalFemale || 0;
}

function reverseCard(styleValue) {
	this.$set(styleValue, 'cardReverse', !styleValue.cardReverse);
}

export default {
	name: 'page-inv-graphic-summary',
	// created,
	data,
	components: {
		areaFilter,
		cardTool,
		downloadBtn,
		graphicStyle,
		rowGraphic,
		titleHeader,
		subsidiaryFilter,
	},
	methods: {
		downloadReport,
		goToBack,
		loadData,
		setGraphics,
		reverseCard,
		changeArea,
		changeSubsidiary,
	},
	mounted,
	props: {
		id: [Number, String],
		idsummary: [Number, String],
	},
};
</script>
<style lang="scss" scoped>
	.main-container-graphic {
		margin-bottom: 80px;
	}
	.wrapper-summary {
		background-color: map-get($colors, white);
		padding: 27px 5px 12px;
		text-align: center;
	}

	.blue-bold {
		font-family: map-get($fonts, bold);
		font-size: map-get($sizes, small);
		text-align: center;
		text-transform: uppercase;
	}

	.wrapper-text {
		border-bottom: 1px solid map-get($colors, gray-slider);
		margin-bottom: 20px;
	}

	.graphic-style {
		width: 100%;
		max-width: 400px; /* Ajusta este valor según tus necesidades */
	}

	.wrapper-btns {
		width: 53%;
    	display: flex;
	}

	.wrapper-close {
		align-items: center;
		background: map-get($colors, white);
		border-top: 1px solid map-get($colors, border-gray);
		bottom: 0;
		display: flex;
		justify-content: center;
		left: 70px;
		padding: 16px 0 19px 0;
		position: fixed;
		right: 0;
	}

	.btn-detail {
		font-family: font(bold) !important;
		font-size: size(small13) !important;

		&-close {
			font-size: size(medium) !important;
		}

		&:not(.btn-detail-close) {
			margin-left: 13px;
		}

		img {
			height: auto !important;
			margin-left: 0px;
			margin-right: 19px;
		}
	}
</style>





// WEBPACK FOOTER //
// src/pages/diagnosis/page-inv-graphic-summary.vue